<template>
  <span id="cnzz"> </span>
</template>

<script>
export default {
  mounted () {
    const sid = '1257885150'
    const cnzzProtocol =
      document.location.protocol === 'https:' ? 'https://' : 'http://'
    const cnzzSpan = document.createElement('span')
    cnzzSpan.setAttribute('id', `cnzz_stat_icon_${sid}`)
    document.getElementById('cnzz').appendChild(cnzzSpan)
    const cnzzScript = document.createElement('script')
    cnzzScript.setAttribute(
      'src',
      `${cnzzProtocol}s5.cnzz.com/z_stat.php?id=${sid}&show=pic`
    )
    document.body.appendChild(cnzzScript)
  }
}
</script>
